export default __webpack_public_path__ + "static/media/BlackPencel.fc9a4177.svg";